// /schedules 검색 필드 정의 (SearchToolbar config).
// 기존 인라인 <TextField> 6개를 이 배열 하나로 대체한다.

import { isCompleteDateString } from "functions/generateFilter";
import type { SearchFieldConfig } from "components/list";

export const scheduleSearchFields: SearchFieldConfig[] = [
  { name: "id", label: "ID", type: "text", operator: "contains", width: 140 },
  { name: "agentName", label: "현장요원 이름", type: "text", operator: "contains", width: 200 },
  { name: "agentCode", label: "현장요원 코드", type: "text", operator: "contains", width: 200 },
  {
    name: "complete",
    label: "상태",
    type: "select",
    operator: "eq",
    width: 160,
    options: [
      { value: "", label: "전체" },
      { value: "incomplete", label: "배정" },
      { value: "confirm", label: "시설수락" },
      { value: "cancel", label: "취소" },
      { value: "complete", label: "완료" },
    ],
  },
  {
    name: "visitDate",
    label: "예정 방문날짜",
    type: "date",
    operator: "eq",
    validate: isCompleteDateString,
    width: 200,
  },
  {
    name: "visitDateFinal",
    label: "실제 방문날짜",
    type: "date",
    operator: "eq",
    validate: isCompleteDateString,
    width: 200,
  },
];
